import { Container, Service } from 'typedi';
import { AttributionPersistence } from './AttributionPersistence';
import { IAppLaunchInfo } from '@sparkware/uc-sdk-core';

@Service()
export class AttributionStore {
    private readonly _attributionPersistence: AttributionPersistence;

    constructor() {
        this._attributionPersistence = Container.get(AttributionPersistence);
    }

    public peek(): string | undefined {
        return this._attributionPersistence.getBusinessCorrelationId();
    }

    public update(launchInfo: IAppLaunchInfo): void {
        if (
            launchInfo &&
            launchInfo.channel?.source !== 'Unified Client' &&
            launchInfo.businessCorrelationID
        ) {
            this._attributionPersistence.updateBusinessCorrelationId(
                launchInfo.businessCorrelationID,
            );
        }
    }

    public clear(businessCorrelationId?: string): void {
        this._attributionPersistence.clearBusinessCorrelationId(businessCorrelationId);
    }

    public consume(): string | undefined {
        const businessCorrelationId = this.peek();

        if (businessCorrelationId !== undefined) {
            this.clear(businessCorrelationId);
        }

        return businessCorrelationId;
    }
}
